import { CamelOrderProp } from '@/pages/store-management/master-stores/components/Sidebar/MasterStoreSidebarForm/service';
import { validBlank } from '@/validate';

export const validateBlankMessage = (
  value: string,
  targgetKeyStr: string
): string => {
  if (value === '') {
    return `${targgetKeyStr}}を入力してください。`;
  }
  return '';
};

export const validateUberDeliveryStoreInput = (
  email: string,
  password: string,
  externalStoreName: string
): boolean => {
  /* メールアドレス */
  const isEmailBrank = validBlank.check(email);
  if (isEmailBrank) {
    alert(validBlank.message('メールアドレス'));
    return true;
  }
  if (!email.includes('@')) {
    alert('メールアドレスの形式が正しくありません。');
    return true;
  }

  if (!email.includes('@')) {
    alert('メールアドレスの形式が正しくありません。');
    return true;
  }

  /* パスワード */
  const isPasswordBrank = validBlank.check(password);
  if (isPasswordBrank) {
    alert(validBlank.message('パスワード'));
    return true;
  }

  if (externalStoreName === '') {
    alert(validBlank.message('統合するUber Eats店舗が選択されていません'));
    return true;
  }

  return false;
};

export const validateMenuDeliveryStoreInput = (
  menuStoreId: string
): boolean => {
  /* menuストアId */
  const isNameBrank = validBlank.check(menuStoreId);
  if (isNameBrank) {
    alert(validBlank.message('menuストアId'));
    return true;
  }
  const reg = new RegExp(/^[0-9]+$/); //上記の正規表現を引数に渡す
  if (!reg.test(menuStoreId)) {
    alert('menuストアIdは半角数字で入力してください。');
    return true;
  }
  return false;
};

export const validateCamelOrderTakeoustDaysOffset = (
  takeoutStartDaysOffset: number,
  takeoutEndDaysOffset: number
): boolean => {
  /* テイクアウト受け取り可能開始日 が テイクアウト受け取り可能終了日 より大きい場合 */
  if (takeoutStartDaysOffset > takeoutEndDaysOffset) {
    alert(
      'テイクアウト受け取り可能期間の開始日は終了日よりも前の日付を選択してください。'
    );
    return true;
  }

  return false;
};

export const validateCamelOrderPropInput = (
  camelOrderProp: CamelOrderProp | null
): boolean => {
  if (camelOrderProp === null) {
    return false;
  }
  if (
    camelOrderProp.takeout_start_days_offset !== null &&
    camelOrderProp.takeout_end_days_offset !== null &&
    validateCamelOrderTakeoustDaysOffset(
      camelOrderProp.takeout_start_days_offset,
      camelOrderProp.takeout_end_days_offset
    )
  ) {
    return true;
  }
  return false;
};

export const validateCamelOrderStoreInput = (
  cookingTime: number | null
): boolean => {
  /* 調理時間 */
  const isCookingTimeBrank = cookingTime === null;
  if (isCookingTimeBrank) {
    alert('調理時間を選択してください。');
    return true;
  }

  return false;
};
